export default __webpack_public_path__ + "static/helm-98573e419c30a695a556444351a4f026.jpg";